import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { User } from "../models/User";

interface AcheteurProps{
    users: User[];
    onAcheteurChange: any;
    user: User[]
}

export default function Acheteurs(props: AcheteurProps){
    return <MultiSelect
    data={props.users}
    onChange={props.onAcheteurChange}
    value={props.user}
    textField="usr_nom"
    placeholder="Acheteur..."
/>
}